import { tv } from 'tailwind-variants';

export const sairButtonStyles = tv({
  base: 'h-12 w-[105px] rounded-lg font-bold text-base text-neutral-lightest cursor-pointer',
  variants: {
    variant: {
      outline: 'border border-neutral-lightest bg-transparent hover:bg-white/10',
      filled: 'bg-primary border-0',
    },
  },
});
